import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

import env from '../../env'

const { datadog: config } = env

if (config) {
  const sharedConfig = {
    service: 'sign-up-flow',
    applicationId: config?.applicationId,
    clientToken: config?.clientToken,
    version: process.env.BUILD_VERSION,
    dist: process.env.BUILD_NUMBER,
  }

  datadogRum.init({
    ...sharedConfig,
    site: 'datadoghq.eu',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    env: config.environment,
    trackUserInteractions: true,
    allowedTracingUrls: config.traces.enabled ? [env.hostname] : [],
    enableExperimentalFeatures: ['feature_flags'],
  })

  datadogLogs.init({
    ...sharedConfig,
    site: 'datadoghq.eu',
    env: config.environment,
    forwardErrorsToLogs: false,
    sessionSampleRate: 100,
  })
}
